// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1ZiGe","resendInfoText":"OnGoingPaymentBox_resendInfoText__29UGm"};